import { useSetAtom } from 'jotai';

import { replyMessageAtom } from '@/components/pages/conversations/SocialInbox/atoms';

import Icon from '@/components/base/Icon';

export const DirectMessagesInputReplyCard = () => {
    const setReplyMessage = useSetAtom(replyMessageAtom);
    return (
        <div className="flex h-14 w-full items-center justify-between rounded-lg rounded-b-none border-[1px] border-b-0 border-icoBlue-200 bg-blue-100 px-5 py-3">
            <div className="flex flex-col gap-1">
                <div className="font-GSemiBold text-sm text-icoBlack">Reply to joe</div>
                <div className="font-GSemiBold text-xs text-icoGray-500">Attachment</div>
            </div>
            <Icon
                onClick={() => setReplyMessage(null)}
                icon="close"
                className="text-12 cursor-pointer text-icoGray-500"
            />
        </div>
    );
};
